import { getImageForProperty } from "../../constants/propertyType";
import {
  AGILYSYS_LOGO_EMAIL_DATA_URI,
  AGILYSYS_LOGO_EMAIL_HEIGHT,
  AGILYSYS_LOGO_EMAIL_WIDTH,
} from "../../constants/agilysysLogoEmail";

export const EMAIL_HEADER_CELL_STYLE =
  "padding:30px 36px 22px;background:linear-gradient(180deg,#ffffff 0%,#f8fffb 100%);border-bottom:1px solid #f0fdf4;";

const emailLogoImg = (
  src: string,
  alt: string,
  width: number,
  height: number | null,
): string => {
  const heightAttr = height ? `height="${height}"` : "";
  const maxHeightStyle = height ? "" : "max-height:56px;";

  return `<img
    src="${src}"
    alt="${alt}"
    width="${width}"
    ${heightAttr}
    style="display:block;border:0;outline:none;width:${width}px;height:auto;${maxHeightStyle}max-width:100%;"
  />`;
};

/** Agilysys wordmark on the left, product logo URL on the right. */
export const buildEmailHeaderRow = (
  productId: number,
  productName?: string,
): string => {
  const productLogoUrl = getImageForProperty(productId);
  const productAlt = productName ? `${productName} logo` : "Product logo";

  return `<table role="presentation" width="100%" cellspacing="0" cellpadding="0">
      <tr>
        <td style="vertical-align:middle;width:50%;">
          ${emailLogoImg(
            AGILYSYS_LOGO_EMAIL_DATA_URI,
            "Agilysys",
            AGILYSYS_LOGO_EMAIL_WIDTH,
            AGILYSYS_LOGO_EMAIL_HEIGHT,
          )}
        </td>
        <td align="right" style="vertical-align:middle;width:50%;">
          ${emailLogoImg(productLogoUrl, productAlt, 140, null)}
        </td>
      </tr>
    </table>`;
};
